'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { PageTitle } from '@/components/Layout/PageTitle';
import type { CmsPageData } from '@/services/cms/pages/CmsPageData';
export interface PageHeaderProps {
  pageData: CmsPageData;
}
export function PageHeader(t0) {
  const $ = _c(2);
  const {
    pageData
  } = t0;
  let t1;
  if ($[0] !== pageData) {
    t1 = pageData.showTitle && pageData.title ? <PageTitle pageData={pageData} /> : null;
    $[0] = pageData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}